module.exports = {
  DOUBLE: 'Amount',
  AMOUNT: 'Amount',
  BOOLEAN: 'boolean',
  TOGGLE: 'toggle',
  INPUT: 'input',
  GET: 'GET',
  POST: 'POST',
  DEV: 'http://api.dev.openbank.es',
  QA: 'http://api.qa.openbank.es',
  STAGING: 'http://api.stg.openbank.es',
  OCULTO: 'http://api.ocu.openbank.es',
  PRODUCCION: 'http://api.openbank.es',
  MOCK: 'https://openb.mockable.io',
  CMS_DEV: 'http://api-qa-campaigns-engine01.aws.ok-cloud.net:8978',
  LOCAL: 'http://127.0.0.1:13000',
  DEV_HOST: 'DEV',
  QA_HOST: 'QA',
  STAGING_HOST: 'STAGING',
  OCULTO_HOST: 'OCULTO',
  PRODUCCION_HOST: 'PRODUCCION',
  MOCK_HOST: 'MOCK',
  CMS_DEV_HOST: 'CMS_DEV',
  LOCAL_HOST: 'LOCAL',
  URL_CONTROLLERS: '/myprofile/notification/management/controller/',
  URL_NOTIFICATIONS: '/myprofile/notification',
  API_URL: '/preferences/v1/preferences',
  API_URL_GET: '/preferences/v1/preferences',
  API_URL_POST: '/preferences/v1/preferences/notifications',
  TOKEN_COOKIE: 'tokenCredential',
  TEXT_WITHOUT_TRANSLATION: '####',
  MAX_LIMIT_INPUT_AMOUNT: 9999999.99,
};
